import { Checkbox, Input, Tooltip, Icon } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { permissions } from './../../../../../../constants';
import { CheckFullSizeHalfSize, trimData } from './../../../../../../services/helper';
import handlePermission from './../../../../../app/handlePermission';
import { checkFieldEmpty, validate, fillKeyTooltip } from './helper';
import { ListChannel } from './../../../../../../constants/setting_channel';
import './styles-prohibited.css';
import { checkContainProhibitedItem } from './../../../../../../services/prohibitedHelper';
import { isArray } from 'util';
import lang from './../../../../../../languages/en'

class RowProhibitedItems extends Component {
    constructor(props) {
        super(props)
        this.state = {
            countError: 0,
            tooltip: '',
            disabled: !handlePermission(permissions.ItemNameUpdateItemName) ? true : false,
            toogle: true,
        }
    }

    static getDerivedStateFromProps(props, state) {
        let { item_code, sku, country_of_origin, jp_title, en_title, id, checked, classes, HasApproveKeyWordBL, ProhibitedKeyWord } = props.itemName
        if (isArray(ProhibitedKeyWord) && ProhibitedKeyWord.length > 0) {
            classes['en_title'] = HasApproveKeyWordBL ? 'warring warring-disable' : 'warring';
        }
        return {
            inputs: {
                checked,
                id,
                sku,
                item_code,
                en_title,
                jp_title,
                country_of_origin,
                HasApproveKeyWordBL,
                ProhibitedKeyWord,
                classes
            }
        }
    }

    onChange = (value, name, maxLength) => {
        let wordMax = CheckFullSizeHalfSize(value, maxLength)
        if (!wordMax) return;
        this.setState({
            inputs: {
                ...this.state.inputs,
                message: '',
                [name]: value
            }
        })
        this.props.changeFieldInput(value, name, this.state.inputs.id, 'onChange')
        this.props.isEditItemFuns('isEdit', true)
    }

    onBlur = (value, name) => {
        let state = this.state
        state.inputs[name] = trimData(value)
        value = trimData(value)
        if (name === 'country_of_origin') {
            value = trimData(value.toUpperCase())
            state.inputs[name] = trimData(value.toUpperCase())
        }
        checkFieldEmpty(value, name, state, 'blur')
        validate(value, name, state, 'blur')
        if (name === 'en_title') {
            this.checkProhibitedItem(value, name, state, 'blur');
        }
        this.props.changeFieldInput(state.inputs[name], name, this.state.inputs.id)
        this.setState({
            ...state,
            tooltip: ''
        }, () => {
            this.props.checkFieldSku(value, name, this.props.itemName.id)
        })
    }

    onFocus = (value, name) => {
        let state = this.state
        checkFieldEmpty(value, name, state, 'focus')
        validate(value, name, state, 'focus')
        if (name === 'en_title') {
            this.checkProhibitedItem(value, name, state, 'focus');
        }
        this.setState({
            ...state
        })
    }

    checkProhibitedItem = (value, name, state, type) => {
        let ProhibitedKeyWord = checkContainProhibitedItem(value, this.props.prohibitedItems);
        this.props.changeFieldInput(ProhibitedKeyWord, 'ProhibitedKeyWord', this.state.inputs.id);
        if (ProhibitedKeyWord.length === 0) {
            this.props.changeFieldInput(false, 'HasApproveKeyWordBL', this.state.inputs.id);
        } else if (ProhibitedKeyWord.length > 0) {
            if (type === 'focus') {
                state.message = ProhibitedKeyWord
                state.tooltip = fillKeyTooltip(name, state)
            }
        }
        return state
    }
    render() {
        let { inputs } = this.state
        let { idItemName, currentShortChannel } = this.props
        let maxSizeSku = currentShortChannel === ListChannel.RAKUTEN.ShortName ? 16 : 60;
        return (
            <tr className='row-item-name row-item-name-prohibited'>
                <td className="checkbox-approved">
                    <Checkbox
                        disabled={this.state.disabled
                            || !inputs.ProhibitedKeyWord
                            || (isArray(inputs.ProhibitedKeyWord) && inputs.ProhibitedKeyWord.length === 0)}
                        name={'checkbox_has_approve_' + inputs.id}
                        checked={inputs.HasApproveKeyWordBL}
                        onChange={e => this.onChange(e.target.checked, 'HasApproveKeyWordBL')}
                    />
                </td>
                <td className='sku'>
                    <Tooltip
                        placement="bottomLeft"
                        visible={this.state.tooltip === 'sku' + this.state.inputs.key}
                        title={this.state.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            disabled
                            className={inputs.classes.sku}
                            onChange={e => this.onChange(e.target.value, 'sku', maxSizeSku)}
                            onBlur={(e) => this.onBlur(e.target.value, 'sku')}
                            onFocus={(e) => this.onFocus(e.target.value, 'sku')}
                            value={inputs.sku}
                            maxLength={60}
                        />
                    </Tooltip>
                </td>
                <td className='item-code'>
                    <Tooltip
                        placement="bottomLeft"
                        visible={this.state.tooltip === 'item_code' + this.state.inputs.key}
                        title={this.state.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            disabled
                            className={`${inputs.classes.item_code}`}
                            value={inputs.item_code}
                            onChange={e => this.onChange(e.target.value, 'item_code', 50)}
                            onBlur={(e) => this.onBlur(e.target.value, 'item_code')}
                            onFocus={(e) => this.onFocus(e.target.value, 'item_code')}
                            maxLength={50}
                        />
                    </Tooltip>
                </td>
                <td className='en-title cols-item-name-prohibited'>
                    <Tooltip
                        placement="bottomLeft"
                        visible={this.state.tooltip === 'en_title' + this.state.inputs.key && !inputs.HasApproveKeyWordBL}
                        title={() => {
                            let message = this.state.message
                            if (isArray(message)) {
                                return `${lang.content_tooltip_warring_prohibited}"${message.join(', ')}"`
                            } else {
                                return message;
                            }

                        }}
                        overlayClassName={isArray(this.state.message) ?
                            ((inputs.HasApproveKeyWordBL) ? 'tooltip-warring-prohibited-disable-2' : 'tooltip-warring-prohibited-2')
                            :
                            'tooltip-error'}
                    >
                        <Input
                            disabled={this.state.disabled}
                            className={`${inputs.classes.en_title}`}
                            onChange={e => this.onChange(e.target.value, 'en_title', 250)}
                            onBlur={(e) => this.onBlur(e.target.value, 'en_title')}
                            onFocus={(e) => this.onFocus(e.target.value, 'en_title')}
                            value={inputs.en_title}
                            maxLength={250}
                            suffix={<Icon type="exclamation" />}
                        />
                    </Tooltip>
                </td>
                <td className='jp-title'>
                    <Tooltip
                        placement="bottomLeft"
                        visible={false}
                        title={this.state.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            disabled
                            className={`${inputs.classes.jp_title}`}
                            value={inputs.jp_title}
                            onChange={e => this.onChange(e.target.value, 'jp_title', 200)}
                            onBlur={(e) => this.onBlur(e.target.value, 'jp_title')}
                            onFocus={(e) => this.onFocus(e.target.value, 'jp_title')}
                            maxLength={200}
                        />
                    </Tooltip>
                </td>
                <td className='country-of-origin'>
                    <Tooltip
                        placement="bottomLeft"
                        visible={this.state.tooltip === 'country_of_origin' + this.state.inputs.key}
                        title={this.state.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            disabled
                            className={`${inputs.classes.country_of_origin}`}
                            value={inputs.country_of_origin}
                            onChange={e => this.onChange(e.target.value, 'country_of_origin', 2)}
                            onBlur={(e) => this.onBlur(e.target.value, 'country_of_origin')}
                            onFocus={(e) => this.onFocus(e.target.value, 'country_of_origin')}
                            maxLength={2}
                        />
                    </Tooltip>
                </td>
            </tr>
        );
    }
}

export default RowProhibitedItems




// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/prohibited-items/row-prohibited-items/index.js